import React from 'react';
import { LegacyComponentEntryPointContainer as PlatformLegacyComponentEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';

export const LegacyComponentEntryPointContainer = (
	props: Parameters<typeof PlatformLegacyComponentEntryPointContainer>[0],
): React.JSX.Element => <PlatformLegacyComponentEntryPointContainer {...props} />;
